import classnames from "classnames";
import styles from "./Button.module.css";

export enum VARIANTS {
  primary = "primary",
  secondary = "secondary",
  info = "info",
  success = "success",
  error = "error",
  warning = "warning",
}

export enum TYPE_BUTTON {
  button,
  submit,
  reset,
}

const Button = ({
  type = TYPE_BUTTON.button,
  variant = VARIANTS.primary,
  children,
  className,
  ...rest
}: ButtonEntity) => (
  <button
    {...rest}
    type={TYPE_BUTTON[type]}
    className={classnames(styles.button, styles[VARIANTS[variant]], className)}
  >
    {children}
  </button>
);

type ButtonEntity = {
  children: any;
  className?: string;
  variant?: VARIANTS;
  type?: TYPE_BUTTON;
};

export default Button;

export const LinkButton = ({
  className,
  variant = VARIANTS.primary,
  href,
  children,
  ...rest
}: LinkButtonEntity) => {
  return (
    <a
      {...rest}
      href={href}
      className={classnames(
        "btn btn-" + [variant] + " rounded-pill p-3 text-light text-uppercase",
        className,
      )}
    >
      {children}
    </a>
  );
};
type LinkButtonEntity = {
  variant?: VARIANTS;
  className?: string;
  href: string;
  children: any;
};
